import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import HomeBuyingTimeline from "@/pages/tools/HomeBuyingTimeline";

export const Route = createFileRoute("/tools/home-buying-timeline")({
  head: () => seoHead("/tools/home-buying-timeline"),
  component: HomeBuyingTimeline,
});
